import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState, useContext, useEffect } from "react";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import { APIContext } from "../../../Contexts/APIContext";

interface ITypeFiltersDialogProps {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    currentType: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function TypeFiltersDialog({ open, setOpen, currentType, changeFilter }: ITypeFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [typeList, setTypeList] = useState<string[]>([])
    const [type, setType] = useState(currentType);

    useEffect(() => {
        get('MonitoringScorecard', `GetScorecardTypes`, (data) => setTypeList(data))
    }, [])

    const confirm = () => {
        changeFilter('type', type);
        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Type Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid size={12} >
                            <Select
                                value={type}
                                onChange={(e) => setType(e.target.value as string)}
                                endAdornment={type &&
                                    <IconButton onClick={() => setType('')} sx={{ marginRight: 2 }}>
                                        <ClearIcon />
                                    </IconButton>}
                                fullWidth>
                                {
                                    typeList.map(item =>
                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}